import { render, staticRenderFns } from "./LangInput.vue?vue&type=template&id=4831a3f9&scoped=true&"
import script from "./LangInput.vue?vue&type=script&lang=js&"
export * from "./LangInput.vue?vue&type=script&lang=js&"
import style0 from "./LangInput.vue?vue&type=style&index=0&id=4831a3f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4831a3f9",
  null
  
)

export default component.exports